var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7423 6.85446L12.576 10.6675L16.4097 6.85446L13.8466 6.85446L13.8466 3.00011L11.3454 3.00011L11.3454 6.85446L8.7423 6.85446Z",
    fill: "#5f00a0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0071 8.19971H16.9601L12.5758 12.0786L8.21885 8.19971H3.15117C2.92947 8.20039 2.71704 8.28876 2.56028 8.44553C2.40351 8.6023 2.31513 8.81473 2.31445 9.03643V20.163C2.31513 20.3847 2.40351 20.5972 2.56028 20.7539C2.71704 20.9107 2.92947 20.9991 3.15117 20.9997H22.0071C22.229 20.9994 22.4418 20.9112 22.5988 20.7544C22.7559 20.5976 22.8444 20.3849 22.8451 20.163V9.03643C22.8444 8.8145 22.7559 8.60188 22.5988 8.44508C22.4418 8.28827 22.229 8.20005 22.0071 8.19971ZM20.202 19.8041L16.478 15.41L12.5927 18.6962L8.6441 15.3157L4.94858 19.8053H3.3397L7.45745 14.1846L3.49335 10.8274L3.45591 9.1733L12.5927 16.3151L21.6946 9.05838V10.8274L17.799 14.1846L21.8328 19.786L20.202 19.8041Z",
    fill: "#5f00a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/send_mail.750da1e20483b32bfe1e947e67c6aff6.svg";
export { ForwardRef as ReactComponent };